import React from 'react'
import { format } from 'date-fns'
import { MainHealthProcedureDetailsContainer, Content } from './styles'

import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ModalListProcedures } from '../../ModalComponents/ModalListProcedures'
import { ModalItemListProcedures } from '../../ModalComponents/ModalItemListProcedures'
import { RelatedTestType } from '..'
import { EHealthProceduresTypes, IOncologyDiagnosis } from '~/interfaces'
import { getTimestamp } from '~/utils'

interface DiagnosisDetailsContentProps {
  diagnosisData: IOncologyDiagnosis
  onOpenRelatedTest: (id: string, type: RelatedTestType) => void
}

export const DiagnosisDetailsContent = ({
  diagnosisData,
  onOpenRelatedTest
}: DiagnosisDetailsContentProps): JSX.Element => {
  return (
    <MainHealthProcedureDetailsContainer>
      <ModalHeader title={diagnosisData?.description} datetime={diagnosisData?.startDate} />

      <Content>
        {diagnosisData.imagingTests.length && (
          <ModalListProcedures title="Biópsia">
            {diagnosisData.imagingTests.map(({ id, description, startDate }) => (
              <ModalItemListProcedures
                key={id}
                type="biopsiaDiagnostico"
                label={description}
                value={getTimestamp(startDate) > 0 ? format(new Date(startDate), 'dd/MM - HH:mm') : undefined}
                onClick={() => onOpenRelatedTest(id, EHealthProceduresTypes.IMAGING_TEST)}
              />
            ))}
          </ModalListProcedures>
        )}

        {diagnosisData.anatomopathologicalTests.length && (
          <ModalListProcedures title="Anatomopatologia">
            {diagnosisData.anatomopathologicalTests.map(({ id, description, startDate }) => (
              <ModalItemListProcedures
                key={id}
                type="exameAnatomopatologico"
                label={description}
                value={getTimestamp(startDate) > 0 ? format(new Date(startDate), 'dd/MM - HH:mm') : undefined}
                onClick={() => onOpenRelatedTest(id, EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST)}
              />
            ))}
          </ModalListProcedures>
        )}
      </Content>
    </MainHealthProcedureDetailsContainer>
  )
}
